export default __webpack_public_path__ + "static/media/cruz.91315bf2.svg";